// extracted by mini-css-extract-plugin
export default {"appName":"AppName_appName__-EF35"};